import { render, staticRenderFns } from "./UserAccountBranding.vue?vue&type=template&id=4d59d2a2&scoped=true&"
import script from "./UserAccountBranding.vue?vue&type=script&lang=js&"
export * from "./UserAccountBranding.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountBranding.vue?vue&type=style&index=0&id=4d59d2a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d59d2a2",
  null
  
)

export default component.exports